// "use client";

// import { useState, useEffect } from 'react';
// import Image from 'next/image';

// const images = [
//   '/assets/images/new_design/kuppam_office.webp',
//   '/assets/images/new_design/billing_counter.webp',
//   '/assets/images/new_design/about_building.webp',
//   '/assets/images/new_design/kuppam_md.webp',
//   '/assets/images/new_design/transformer.webp',
//   '/assets/images/new_design/kuppam_staff.webp',
// ];

// export default function ImageSlideshow() {
//   const [currentGroup, setCurrentGroup] = useState(0);
//   const totalGroups = Math.ceil(images.length / 3) - 1;

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentGroup((prev) => (prev >= totalGroups ? 0 : prev + 1));
//     }, 2000);

//     return () => clearInterval(interval);
//   }, [totalGroups]);

//   // Get current group of 3 images
//   const currentImages = images.slice(currentGroup * 3, currentGroup * 3 + 3);

//   return (
//     <div className="w-full">
//       <div className="flex gap-4 mb-4">
//         {currentImages.slice(0, 2).map((src, index) => (
//           <div key={`top-${index}`} className=" w-1/2 aspect-video">
//             <Image
//               src={src}
//               alt={`Slide ${currentGroup * 3 + index + 1}`}
//               width={600}
//               height={400}
//               className="object-cover h-full w-full rounded-lg shadow-md"
//             />
//           </div>
//         ))}
//       </div>

//       <div>
//           <div className="h-[250px] w-full aspect-video">
//             <Image
//               src={currentImages[2]}
//               alt={`Slide ${currentGroup * 3 + 3}`}
//               width={800}
//               height={450}
//               className="object-cover h-full w-full rounded-lg shadow-md"
//             />
//           </div>
//       </div>
//     </div>
//   );
// }

// components/ImageSlideshow.tsx
"use client";

import { useState, useEffect } from "react";
import Image from "next/image";

const images = [
  "/assets/images/new_design/kuppam_office.webp",
  "/assets/images/new_design/billing_counter.webp",
  "/assets/images/new_design/about_building.webp",
  "/assets/images/new_design/kuppam_md.webp",
  "/assets/images/new_design/transformer.webp",
  "/assets/images/new_design/kuppam_staff.webp",
];

export default function ImageSlideshow() {
  const [currentGroup, setCurrentGroup] = useState(0);
  const [motionToggle, setMotionToggle] = useState(false);
  const totalGroups = Math.ceil(images.length / 3) - 1;

  useEffect(() => {
    const interval = setInterval(() => {
      setMotionToggle((prev) => !prev);
      setTimeout(() => {
        setCurrentGroup((prev) => (prev >= totalGroups ? 0 : prev + 1));
      }, 500);
    }, 2000);

    return () => clearInterval(interval);
  }, [totalGroups]);

  const currentImages = images.slice(currentGroup * 3, currentGroup * 3 + 3);

  return (
    <div className="w-full">
      <div className="flex gap-4 justify-center mb-4 h-[200px]">
        <div
          className={`transition-all duration-500 ease-in-out ${
            motionToggle ? "w-[54%]" : "w-[46%]"
          } h-full`}
        >
          <Image
            src={currentImages[0]}
            alt={`Slide ${currentGroup * 3 + 1}`}
            width={600}
            height={400}
            sizes="(max-width: 640px) 100vw, (max-width: 768px) 60vw, (max-width: 1280px) 50vw, 40vw"
            className="object-cover h-full w-full rounded-lg shadow-md"
            unoptimized
          />
        </div>

        {/* Second image - opposite animation of first */}
        <div
          className={`transition-all duration-500 ease-in-out ${
            motionToggle ? "w-[46%]" : "w-[54%]"
          } h-full`}
        >
          <Image
            src={currentImages[1]}
            alt={`Slide ${currentGroup * 3 + 2}`}
            width={600}
            height={400}
            sizes="(max-width: 640px) 100vw, (max-width: 768px) 60vw, (max-width: 1280px) 50vw, 40vw"
            className="object-cover h-full w-full rounded-lg shadow-md"
            unoptimized
          />
        </div>
      </div>

      <div className="flex justify-center h-[250px]">
        {currentImages.length > 2 && (
          <div className="w-full h-full transition-opacity duration-500">
            <Image
              src={currentImages[2]}
              alt={`Slide ${currentGroup * 3 + 3}`}
              width={800}
              height={450}
              sizes="(max-width: 640px) 100vw, (max-width: 768px) 60vw, (max-width: 1280px) 50vw, 40vw"
              className="object-cover h-full w-full rounded-lg shadow-md"
              unoptimized
            />
          </div>
        )}
      </div>
    </div>
  );
}
